import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-save-your-changes.title',
		defaultMessage: 'Save your changes',
		description: 'The title for the spotlight',
	},
	content: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-save-your-changes.content',
		defaultMessage:
			"Your plan is a sandbox environment, meaning the changes you make here aren't committed until you're ready. Use this button to save your changes and get down to work.",
		description: 'The content for the spotlight',
	},
});
